/* eslint-disable default-param-last */
import { HYDRATE } from 'next-redux-wrapper';
import merge from 'deepmerge';
import { CONFIRMATION_STATUS, SCREEN_TYPES } from '@/utils/constants';
import getUUID from '@gc-npm/utils.monitoring.get-uuid';

export const types = {
  INITIALIZE_CONFIG: 'UI/INITIALIZE_CONFIG',
  SET_SCREEN_TYPE: 'UI/SET_SCREEN_TYPE',
  SET_LAYOUT: 'UI/SET_LAYOUT',
  SET_AUTO_SELECTION: 'UI/SET_AUTO_SELECTION',
  SET_CONFIRMATION: 'UI/SET_CONFIRMATION',
  SEND_RETENTION_PROMO: 'UI/SEND_RETENTION_PROMO',
  SEND_BACKOFFICE: 'UI/SEND_BACKOFFICE',
  SET_RECAPTCHA: 'UI/SET_RECAPTCHA',
  SET_TAPON: 'UI/SET_TAPON',
  SEND_TAPON_METRICS: 'UI/SEND_TAPON_METRICS',
  SET_NOTIFICATION: 'UI/SET_NOTIFICATION',
  RESET_NOTIFICATION: 'UI/RESET_NOTIFICATION',
  SET_CALL_OUT: 'UI/SET_CALL_OUT',
  SET_SEO_DATA: 'UI/SET_SEO_DATA',
  SET_DEVICE_SLIDER_DATA: 'UI/SET_DEVICE_SLIDER_DATA',
  NAVIGATE_2_PURCHASE_PROCESS: 'UI/NAVIGATE_2_PURCHASE_PROCESS',
  NAVIGATE_2_LOGIN: 'UI/NAVIGATE_2_LOGIN',
  NAVIGATE_2_URL: 'UI/NAVIGATE_2_URL',
  SET_SHOW_RECOMENDATOR: 'UI/SET_SHOW_RECOMENDATOR',
  SET_OP_VERSUS: 'UI/SET_OP_VERSUS',
  GET_PERMANENCE: 'UI/GET_PERMANENCE',
  SET_PERMANENCE: 'UI/SET_PERMANENCE',
  SET_BOUNCING_LOGO: 'UI/SET_BOUNCING_LOGO',
  SEND_PUSSUB: 'UI/SEND_PUSSUB',
  SET_PROCESS_ID: 'UI/SET_PROCESS_ID',
  SET_CONFIG_LAYOUT_REQUIREMENT: 'UI/SET_CONFIG_LAYOUT_REQUIREMENT',
  SET_MINOR_LM_PRICE: 'UI/SET_MINOR_LM_PRICE',
  SET_USER_AGENT: 'UI/SET_USER_AGENT',
  /* nextjs */
  HYDRATE: 'MAIN/HYDRATE',
};



export const actions = {
  initializeConfig: (
    data = {
      build: false,
      mode: 'config',
      isProductosRecomendados: false,
    },
  ) => ({ type: types.INITIALIZE_CONFIG, ...data }),
  setScreenType: (data) => ({ type: types.SET_SCREEN_TYPE, screenType: data }),
  setLayout: (data) => ({ type: types.SET_LAYOUT, layout: data }),
  setProcessId: (data) => ({ type: types.SET_PROCESS_ID, processId: data }),
  setAutoSelection: (data) => ({
    type: types.SET_AUTO_SELECTION,
    autoSelection: data,
  }),
  setConfirmation: (data) => ({
    type: types.SET_CONFIRMATION,
    confirmation: data,
  }),
  sendRetentionPromo: (data) => ({ type: types.SEND_RETENTION_PROMO, ...data }),
  sendBackoffice: (data) => ({ type: types.SEND_BACKOFFICE, ...data }),
  setRecaptcha: (data) => ({ type: types.SET_RECAPTCHA, recaptcha: data }),
  setTapon: (data) => ({ type: types.SET_TAPON, tapon: data }),
  sendTaponMetrics: (data) => ({ type: types.SEND_TAPON_METRICS, ...data }),
  setNotification: (data) => ({ type: types.SET_NOTIFICATION, notification: data }),
  setCallOut: (data) => ({ type: types.SET_CALL_OUT, callOut: data}),
  resetNotification: () => ({ type: types.RESET_NOTIFICATION }),
  setSeoData: (data) => ({ type: types.SET_SEO_DATA, seo: data }),
  setDeviceSliderData: (data) => ({ type: types.SET_DEVICE_SLIDER_DATA, deviceSlider: data }),
  navigate2PurchaseProcess: (data) => ({
    type: types.NAVIGATE_2_PURCHASE_PROCESS,
    ...data,
  }),
  navigate2Login: (data) => ({ type: types.NAVIGATE_2_LOGIN, params: data }),
  setShowRecomendator: (data) => ({ type: types.SET_SHOW_RECOMENDATOR, showRecomendator: data }),
  setOpVersus: (data) => ({ type: types.SET_OP_VERSUS, opVersus: data }),
  navigate2Url: (data) => ({ type: types.NAVIGATE_2_URL, ...data }),
  getPermanence: (data) => ({
    type: types.GET_PERMANENCE,
    modulos: data,
  }),
  setPermanence: (data) => ({
    type: types.SET_PERMANENCE,
    permanence: data,
  }),
   setBouncingLogo: (data) => ({
    type: types.SET_BOUNCING_LOGO,
    bouncingLogo: data,
  }),
   sendPubSub: (data) => ({
    type: types.SEND_PUSSUB,
    ...data,
  }),
   setConfigLayoutRequiement: (data) => ({
    type: types.SET_CONFIG_LAYOUT_REQUIREMENT,
    configLayoutRequirement: data,
  }),
  setMinorPriceLm: (data) => ({
    type: types.SET_MINOR_LM_PRICE,
    minorLMPrice: data,
  }),
  setUserAgent: (data) => ({
    type: types.SET_USER_AGENT,
    userAgent: data,
  }),
};

const initialState = {
  screenType: SCREEN_TYPES.MOBILE,
  isScreenTypeCalculated: false,
  layout: null,
  autoSelection: null,
  recaptcha: false,
  tapon: null,
  notification: null,
  seo: null,
  confirmation: null,
  permanence: 'Sin permanencia',
  deviceSlider: null,
  showRecomendator: null,
  opVersus: null,
  bouncingLogo: false,
  processId: null,
  configLayoutRequirement: null,
  minorLMPrice: null,
  userAgent: null,
};

function reducer(state = { ...initialState }, action) {
  switch (action.type) {
    case HYDRATE: {
      const { UI } = action.payload;
      /* neceisto preservar lo que viene del sever excepto los filtros */
      const nextState = merge(state, UI);

      if (state.isScreenTypeCalculated) {
        return {
          ...nextState,
          screenType: state.screenType,
          isScreenTypeCalculated: true,
        };
      }

      if (!nextState.screenType) {
        return {
          ...nextState,
          screenType: state.screenType,
        };
      }

      return nextState;
    }
    case types.SET_SCREEN_TYPE: {
      const { screenType } = action;
      return {
        ...state,
        screenType,
        isScreenTypeCalculated: true,
      };
    }
    case types.SET_LAYOUT: {
      const { layout } = action;
      return {
        ...state,
        layout,
      };
    }
    case types.SET_AUTO_SELECTION: {
      const { autoSelection } = action;
      return {
        ...state,
        autoSelection,
      };
    }
    case types.SET_NOTIFICATION: {
      const { notification } = action;
      return {
        ...state,
        notification,
      };
    }
    case types.RESET_NOTIFICATION: {
      return {
        ...state,
        notification: initialState.notification,
      };
    }
    case types.SET_CALL_OUT: {
      const { callOut } = action;
      return {
        ...state,
        callOut,
      };
    }
    case types.SET_SEO_DATA: {
      const { seo } = action;
      return {
        ...state,
        seo,
      };
    }
    case types.SET_DEVICE_SLIDER_DATA: {
      const { deviceSlider } = action;
      return {
        ...state,
        deviceSlider,
      };
    }
    case types.SET_CONFIRMATION: {
      const { confirmation } = action;
      return {
        ...state,
        confirmation: {
          ...state.confirmation,
          ...confirmation,
        },
      };
    }
    case types.SEND_RETENTION_PROMO:
    case types.SEND_BACKOFFICE: {
      return {
        ...state,
        confirmation: {
          ...state.confirmation,
          status: CONFIRMATION_STATUS.LOADING,
        },
      };
    }
    case types.SET_RECAPTCHA: {
      const { recaptcha } = action;
      return {
        ...state,
        recaptcha,
      };
    }
    case types.SET_TAPON: {
      const { tapon } = action;
      return {
        ...state,
        tapon,
      };
    }
    case types.SET_PERMANENCE: {
      const { permanence } = action;
      return {
        ...state,
        permanence,
      };
    }
    case types.SET_BOUNCING_LOGO: {
      const { bouncingLogo } = action;
      return {
        ...state,
        bouncingLogo,
      };
    }
    case types.SET_SHOW_RECOMENDATOR: {
      const { showRecomendator } = action;
      return {
        ...state,
        showRecomendator,
      };
    }
    case types.SET_OP_VERSUS: {
      const { opVersus } = action;
      return {
        ...state,
        opVersus,
      };
    }
    case types.SET_PROCESS_ID : {
      const { processId } = action;
      return {
        ...state,
        processId,
      }
    }
    case types.SET_CONFIG_LAYOUT_REQUIREMENT : {
      const { configLayoutRequirement } = action;
      return {
        ...state,
         configLayoutRequirement,
      }
    }
     case types.SET_MINOR_LM_PRICE : {
      const { minorLMPrice } = action;
      return {
        ...state,
         minorLMPrice,
      }
    }
     case types.SET_USER_AGENT : {
      const { userAgent } = action;
      return {
        ...state,
         userAgent,
      }
    }

    default:
      return state;
  }
}

export default reducer;
